import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';
import TableCell from 'components/TableCell';

import { HotelListRow_hotel$key } from '__generated__/HotelListRow_hotel.graphql';

type Props = EntityTableRowProps & {
  hotel: HotelListRow_hotel$key;
};

const HotelListRow: FC<Props> = ({ hotel, ...props }) => {
  const hotelData = useFragment(
    graphql`
      fragment HotelListRow_hotel on Hotel {
        id
        name
        source

        ...EntityTableRow_entity
      }
    `,
    hotel
  );

  const { id, name, source } = hotelData;

  return (
    <EntityTableRow entity={hotelData} {...props}>
      <TableCell>
        <Link href={`/hotels/${id}`}>{name}</Link>
      </TableCell>

      <TableCell center>{source}</TableCell>
    </EntityTableRow>
  );
};

export default HotelListRow;
